export default {
    get() {
        return this._items;
    },

    _items: [
        {
            heading: '24/7, on-demand access',
            body: 'All our courses and resources are accessible in the cloud (online), on-demand, 24/7. Whether you’re sitting in your office, at home, in a hotel, or anywhere in between... knowledge is always just a login away.',
            image: '/images/app/about-icons-ondemand.svg'
        },
        {
            heading: 'Pay less, get more',
            body: 'Our membership model increases your choices and reduces your costs. As a member, you only pay a fixed monthly or annual membership fee to access our entire catalogue. No limits, hidden fees or extra charges. And while you’re busy learning, we’re busy adding new courses, tools and resources.',
            image: '/images/app/about-icons-payless.svg'
        },
        {
            heading: 'Diversify your learning',
            body: 'Say goodbye to compromise. With unrestricted access to courses and the most diverse range of topics available anywhere, you get more choice over what you learn. From therapist self-care strategies through to neuroscience and evidence-based interventions… we’ve got you covered.',
            image: '/images/app/about-icons-diversify.svg'
        },
        {
            heading: 'Control how you learn',
            body: 'Learning comes to you, not the other way around. With global mental health experts and cutting-edge research just a click away... you set your own pace and plan your PD around your availability.',
            image: '/images/app/about-icons-controllearn.svg'
        },
        {
            heading: `Don't miss anything`,
            body: 'Advancing your knowledge has never been easier. You can review completed courses at any time. Missing out on learning due to life-events, bad traffic, toilet breaks or missing paperwork is a thing of the past.',
            image: '/images/app/about-icons-dontmiss.svg'
        }
    ]
}